module.exports = __webpack_public_path__ + "static/media/progress.27248c4c.gif";